import { getDomains, addDomain, updateDomain, deleteDomain, getGlobalDelay, updateGlobalDelay } from '../lib/localStorage/service';
import type { DomainEntry } from '../lib/localStorage/types';

let currentUserId: string | undefined;

export function setCurrentUserId(userId: string) {
  currentUserId = userId;
}

export function getDomainsForUser(): DomainEntry[] {
  return getDomains();
}

export function addNewDomain(domain: Omit<DomainEntry, 'id'>): DomainEntry {
  return addDomain(domain);
}

export function updateExistingDomain(domainId: string, updates: Partial<DomainEntry>): DomainEntry | null {
  return updateDomain(domainId, updates);
}

export function deleteExistingDomain(domainId: string): boolean {
  return deleteDomain(domainId);
}

export function getGlobalDelaySettings(): { days: number; hours: number; minutes: number } {
  return getGlobalDelay();
}

export function updateGlobalDelaySettings(delay: { days: number; hours: number; minutes: number }): void {
  updateGlobalDelay(delay);
} 